import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addGallery } from '../../../slice/gallerySlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Add = () => {
    const [formData, setFormData] = useState({
        title: '',
        location: '',
        status: 1
    });
    const [images, setImages] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.gallery);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setImages(e.target.files);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (images.length === 0) {
            toast.error('Please select at least one image');
            return;
        }

        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => data.append(key, val));
        for (let i = 0; i < images.length; i++) {
            data.append('images', images[i]);
        }

        dispatch(addGallery(data));
        toast.success('Gallery item added successfully!');
        setTimeout(() => navigate('/khajuraho/gallery'), 1500);
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Gallery Item</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-12 mt-2">
                        <label htmlFor="title" className="adminlables">Title</label>
                        <input type="text" id="title" name="title" value={formData.title} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="location" className="adminlables">Location</label>
                        <input type="text" id="location" name="location" value={formData.location} className="form-control" onChange={handleChange} placeholder="e.g. Khajuraho" />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="status" className="adminlables">Status</label>
                        <select id="status" name="status" value={formData.status} className="form-control" onChange={handleChange}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="images" className="adminlables">Upload Images (Multiple)</label>
                        <input type="file" id="images" className="form-control filebg" onChange={handleFileChange} multiple required />
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Adding...' : 'Add Gallery'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Add;
